module.exports = __webpack_public_path__ + "img/5494ae1.jpg";